import { IStudent, IUser } from 'store/reducers/user/types';

export function isStudent(user: IUser): user is IStudent {
    return 'group' in user;
}
